<div class="store-actions">
    <div class="button-row">
        <div class="item">
            <button class="common-button" (click)="reset()">{{ resetButtonText }}</button>
        </div>
        <div class="item">
            <button class="common-button" (click)="submit()">{{ submitButtonText }}</button>
        </div>
    </div>
    @if (submitted) {
        <div class="text-row">
            <p>{{ submittedText }}</p>
        </div>
    }
</div>
